import { Api } from 'Utils/api';
import type { CustomMenuLinksResponse } from './types';

const getHeaders = (ssoToken: string) => ({
  'X-GHL-SSO': ssoToken,
});

export const listCustomMenuLinks = async (
  companyId: string,
  ssoToken: string,
): Promise<CustomMenuLinksResponse> => {
  const response = await Api.get(`/companies/${companyId}/ghl/custom-menu-links`, {
    headers: getHeaders(ssoToken),
  });
  return response.data;
};

export const addLocation = async (
  companyId: string,
  linkId: string,
  locationId: string,
  ssoToken: string,
): Promise<void> => {
  await Api.post(
    `/companies/${companyId}/ghl/custom-menu-links/${linkId}/locations`,
    { location_id: locationId },
    { headers: getHeaders(ssoToken) },
  );
};

export const removeLocation = async (
  companyId: string,
  linkId: string,
  locationId: string,
  ssoToken: string,
): Promise<void> => {
  await Api.delete(`/companies/${companyId}/ghl/custom-menu-links/${linkId}/locations`, {
    data: { location_id: locationId },
    headers: getHeaders(ssoToken),
  });
};
